import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

const AuthenticationCheck = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const [checkComplete, setCheckComplete] = useState(false);

  useEffect(() => {
    const validateUser = async () => {
      if (inProgress !== InteractionStatus.None) {
        console.log("Interaction in progress, waiting...");
        return;
      }

      // Ensure accounts array exists and is not empty
      if (!accounts || accounts.length === 0) {
        console.log("No accounts detected, triggering login redirect...");
        try {
          await instance.loginRedirect(loginRequest);
        } catch (error) {
          if (error.errorCode !== "interaction_in_progress") {
            console.error("Login redirect failed:", error);
          } else {
            console.log("Login already in progress.");
          }
        }
        return;
      }

      // We have an account
      const account = accounts[0];
      console.log("Validating user account...");

      const isValidTenant = account?.tenantId === process.env.REACT_APP_TENANT_ID;
      const isValidClientId = account?.idTokenClaims?.aud === process.env.REACT_APP_CLIENT_ID;

      if (!isValidTenant || !isValidClientId) {
        console.warn("User does not match the required tenant or client ID, logging out...");
        try {
          await instance.logoutRedirect();
        } catch (error) {
          console.error("Logout redirect failed:", error);
        }
        return;
      }

      // User is valid -> Allow rendering
      setCheckComplete(true);
    };

    validateUser();
  }, [instance, accounts, inProgress]);

  if (!checkComplete) {
    return <div>Validating user...</div>;
  }

  return children;
};

export default AuthenticationCheck;